import { defineStore } from "pinia";
import { useUserStore } from "@/stores/UserStore";
import mainAPI from "@/api/mainAPI";
import MyPlugin from "@/plugins/plugin";
import languages from "@/configs/language";
import { useGeneralStore } from "@/stores/GeneralStore";

export const useNotification = defineStore("NotificationStore", {
  state: () => ({
    notificationData: [],
  }),
  getters: {},
  actions: {
    async getNotification(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "GETNOTIFICATION",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        this.notificationData = resp.data;
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },
    async readNotification(params) {
      const userStore = useUserStore();
      let generalStore = useGeneralStore();

      let timestamp = MyPlugin.formatDate(new Date(), "timestamp");

      let apiData = {
        apirequest: "READNOTIFICATION",
        user_id: userStore.user_id,
        user_key: userStore.user_key,
        timestamp: timestamp,
      };

      let body = {
        apidata: apiData,
        params: params,
      };

      let signature = MyPlugin.generateSignature(
        body,
        userStore.user_key,
        timestamp
      );

      let header = {
        "X-Signature": signature,
      };

      let res = await mainAPI.requestHandler(header, body);

      if (res && res.status && res.status == 200 && res.data.status == "ok") {
        let resp = { status: "ok", message: "Success", data: res.data.data };
        return resp;
      } else {
        let resp = {
          status: "not-ok",
          message: `${
            languages[generalStore.$state.choosedLanguage]["err_msg_500"]
          }.`,
        };
        if (
          res &&
          res.status &&
          res.status == 400 &&
          res.data &&
          res.data.msg
        ) {
          resp.message = res.data.msg;
        }

        return resp;
      }
    },
  },
});
